import * as React from "react";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { RiCheckLine } from "react-icons/ri";

import { Link, useNavigate, useParams } from "react-router-dom";
import { RiArrowLeftLine, RiDeleteBinLine } from "react-icons/ri";

import Button from "../../../Components/Button";
import Paper from "../../../Components/Paper";
import Dropzone from "../../../Components/Dropzone";
import SidebarRightFinancingRequest from "../../../Components/SidebarRightFinancingRequest";

import { FileExtImg } from "../../../Functions/files";

import axiosInstance from "../../../Api/Axios";
import { useToast } from "../../../Context/ToastContext";
import { useLoader } from "../../../Context/LoaderContext";

import "./FinancingRequestStep2.scss";

const initialFormState = {
  cin: [],
  patente: [],
  facture_proforma: [],
  carte_professionnelle: [],
  rne: [],
  releves_bancaires: [],
  facture_sone_de_steg: [],
  certificat_de_degrevement_fiscal: [],
  permis_de_conduire: [],
  rib: [],
  statuts_a_jour: [],
  repartition_du_capital: [],
  pouvoirs_du_gerant: [],
  bilans_et_comptes_annexes: [],
  attestation_agriculture: [],
  titre_de_propriete: [],

  taxe_de_transport: [],
  step: "documents",
};

const FinancingRequestStep2 = () => {
  const [valRegister, setValRegister] = React.useState(initialFormState);
  const [formErrorMessages, setFormErrorMessages] = React.useState("");
  const [requestType, setRequestType] = React.useState("");

  const [fileNameDropzone, setFileNameDropzone] = React.useState({});
  const [removedTitleAgricule, setRemovedTitleAgricule] = React.useState(false);
  const [removedReparationCapital, setRemovedReparationCapital] =
    React.useState(false);
  const [removedPouvoirGerants, setRemovedPouvoirGerants] =
    React.useState(false);

  const navigate = useNavigate();
  const { id } = useParams();
  const { addToast } = useToast();
  const { setIsLoading } = useLoader();

  const handleChangeField = (val, key) => {
    setFormErrorMessages((prev) => ({
      ...prev,
      [key]: "",
    }));

    setValRegister((prev) => ({
      ...prev,
      [key]: val,
    }));
  };

  const convertFileToBase64 = (file, fieldName) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      // `reader.result` contains the Base64-encoded file data
      // const base64String = reader.result.split(",")[1];
      const base64String = reader.result; // Remove the data URL prefix

      handleChangeField(base64String, fieldName); // Set the Base64 string to state
    };

    reader.readAsDataURL(file); // Read the file as a Data URL
  };

  async function fetchAndReturnFile(url) {
    try {
      // Faire une requête pour obtenir l'image
      const response = await fetch(url);

      // Vérifier si la requête a réussi
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      // Convertir la réponse en un Blob
      const blob = await response.blob();

      // Créer un objet File à partir du Blob
      const file = new File([blob], "image.png", { type: blob.type });

      return file; // Retourner l'objet File
    } catch (error) {
      console.error("Erreur lors du téléchargement de l'image:", error);
      throw error; // Propager l'erreur pour que l'appelant puisse la gérer
    }
  }

  // React.useEffect(() => {
  //   setIsLoading(true);

  //   axiosInstance
  //     .get(`${process.env.REACT_APP_API_URL}/get-request-with-simulation/${id}`)
  //     .then(async (response) => {
  //       setIsLoading(false);
  //       setRequestType(response.data?.data?.request_type);

  //       const documents = response.data?.data?.documents || [];

  //       documents.map((element) => {
  //         const urls = documents.map((element) => element.url);

  //         setValRegister(urls);
  //         const formData = new FormData();

  //         formData.append(element.slug, urls);
  //       });

  //       // const files = await Promise.all(
  //       //   documents.map(async (element) => {
  //       //     try {
  //       //       return await fetchAndReturnFile(element.url);
  //       //     } catch (error) {
  //       //       console.error(
  //       //         `Error fetching file from URL ${element.url}:`,
  //       //         error
  //       //       );
  //       //       return null; // Retourner null si une erreur survient
  //       //     }
  //       //   })
  //       // );

  //       // // Filtrer les fichiers non nulls
  //       // const validFiles = files.filter((file) => file !== null);

  //       // // Appeler handleChangeField pour chaque fichier valide
  //       // validFiles.forEach((file, index) => {
  //       //   handleChangeField(file, documents[index].slug);
  //       // });

  //       // // Exemple de mise à jour d'état si nécessaire
  //       // setValRegister(documents);
  //     })
  //     .catch((error) => {
  //       setIsLoading(false);
  //       console.error("Error fetching data:", error);
  //     });
  // }, [id, setIsLoading]);

  React.useEffect(() => {
    setIsLoading(true);

    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/get-request-with-simulation/${id}`)
      .then(async (response) => {
        setIsLoading(false);
        setRequestType(response.data?.data?.request_type);

        const documents = response.data?.data?.documents || [];

        for (const element of documents) {
          // const fileName = element.url.split("/").pop();
          // console.log('fileName', fileName)
          const fileNameExtension =
            element.file_name + "." + element.file_extension;
          setFileNameDropzone((prevState) => ({
            ...prevState, // keep all other key-value pairs
            [element.slug]: fileNameExtension, // update the value of specific key
          }));
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching data:", error);
      });
  }, [id, setIsLoading]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);

    const formData = new FormData();

    formData.append(
      "cin",
      valRegister?.carte_professionnelle && valRegister?.cin
    );

    formData.append(
      "patente",
      valRegister?.carte_professionnelle && valRegister?.patente
    );
    formData.append(
      "facture_proforma",
      valRegister?.carte_professionnelle && valRegister?.facture_proforma
    );
    formData.append(
      "carte_professionnelle",
      valRegister?.carte_professionnelle && valRegister?.carte_professionnelle
    );
    formData.append(
      "rne",
      valRegister?.carte_professionnelle && valRegister?.rne
    );
    formData.append(
      "releves_bancaires",
      valRegister?.carte_professionnelle && valRegister?.releves_bancaires
    );
    formData.append(
      "facture_sone_de_steg",
      valRegister?.carte_professionnelle && valRegister?.facture_sone_de_steg
    );
    formData.append(
      "certificat_de_degrevement_fiscal",
      valRegister?.carte_professionnelle &&
        valRegister?.certificat_de_degrevement_fiscal
    );
    formData.append(
      "permis_de_conduire",
      valRegister?.carte_professionnelle && valRegister?.permis_de_conduire
    );
    formData.append(
      "rib",
      valRegister?.carte_professionnelle && valRegister.rib
    );

    // Cas d’un agriculteur
    formData.append(
      "attestation_agriculture",
      valRegister?.carte_professionnelle && valRegister?.attestation_agriculture
    );
    formData.append(
      "titre_de_propriete",
      valRegister?.carte_professionnelle && valRegister?.titre_de_propriete
    );
    formData.append(
      "taxe_de_transport",
      valRegister?.carte_professionnelle && valRegister?.taxe_de_transport
    );

    // Cas d’une entreprise
    formData.append(
      "statuts_a_jour",
      valRegister?.carte_professionnelle && valRegister.statuts_a_jour
    );
    formData.append(
      "repartition_du_capital",
      valRegister?.carte_professionnelle && valRegister.repartition_du_capital
    );
    formData.append(
      "pouvoirs_du_gerant",
      valRegister?.carte_professionnelle && valRegister.pouvoirs_du_gerant
    );
    formData.append(
      "bilans_et_comptes_annexes",
      valRegister?.bilans_et_comptes_annexes &&
        valRegister.bilans_et_comptes_annexes
    );
    formData.append("step", "documents");
    formData.append("request_type", requestType);
    formData.append("simulation_id", id);
    formData.append("titre_de_propriete_deleted", removedTitleAgricule);
    formData.append("repartition_du_capital_deleted", removedReparationCapital);
    formData.append("pouvoirs_du_gerant_deleted", removedPouvoirGerants);

    axiosInstance
      .post(
        `${process.env.REACT_APP_API_URL}/financing-request/update`,
        formData
      )
      .then((response) => {
        setIsLoading(false);
        if (response.data.status) {
          addToast({
            variant: "success",
            message: response.data.message,
          });
          navigate(`/financing-request/recovery/${id}`);
        }
      })
      .catch((error) => {
        setIsLoading(false);

        if (error.response.data.errors) {
          setFormErrorMessages(error.response.data.errors);
          addToast({
            variant: "danger",
            message: error.response.data.message,
          });
        } else {
          addToast({
            variant: "danger",
            message: error.response.data.message,
          });
        }
      });
  };

  const removeElement = (key) => {
    setFileNameDropzone((prevImages) => ({
      ...prevImages,
      [key]: null,
    }));
    if (key === "titre_de_propriete") {
      setRemovedTitleAgricule((prev) => !prev);
    }
    if (key === "repartition_du_capital") {
      setRemovedReparationCapital((prev) => !prev);
    }
    if (key === "pouvoirs_du_gerant") {
      setRemovedPouvoirGerants((prev) => !prev);
    }
  };

  return (
    <>
      <Link
        to={`/financing-request/information-applicant/${id}`}
        className="link-back-financing"
      >
        <RiArrowLeftLine />
      </Link>
      <h1>Documents à Joindres</h1>
      <p>
        Liste des documents nécessaires à l'analyse de votre demande de
        financement
      </p>
      <Paper>
        <div className="wrap-steps-sidebar-not-connected">
          <div className="steps-sidebar-not-connected  visited">
            1. Informations Clients
            <RiCheckLine />
          </div>

          <div className="steps-sidebar-not-connected active">
            2. Documents à Joindre
          </div>
          <div className="steps-sidebar-not-connected">3. Récapitulatif</div>
        </div>
        <Row>
          <Col md={8}>
            <div className="step-simulateur">
              <form
                className="register-form"
                onSubmit={handleSubmit}
                noValidate
              >
                <div className="step-financing-request">
                  {requestType === "farmer" && (
                    <>
                      {fileNameDropzone.attestation_agriculture ? (
                        <>
                          <div className="wrap-result-files">
                            <label className="dropzone-component-label">
                              Attestation d'agriculture UTAP ou SYNAGRI
                            </label>
                            <div className="wrap-link-files">
                              <div className="wrap-name-files">
                                {FileExtImg(
                                  fileNameDropzone.attestation_agriculture || ""
                                )}
                                {fileNameDropzone.attestation_agriculture}
                              </div>
                              <RiDeleteBinLine
                                onClick={() =>
                                  removeElement("attestation_agriculture")
                                }
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <Dropzone
                            label="Attestation d'agriculture UTAP ou SYNAGRI"
                            name="attestation_agriculture"
                            hasError={formErrorMessages.attestation_agriculture}
                            errorMessage={
                              <div className="text-danger">
                                {formErrorMessages.attestation_agriculture}
                              </div>
                            }
                            value={valRegister.attestation_agriculture || []}
                            onChange={(files) => {
                              files[0] &&
                                convertFileToBase64(
                                  files[0],
                                  "attestation_agriculture"
                                );
                            }}
                            required
                            accept="image/*,.pdf"
                            description={
                              <>
                                Cette dropzone accepte les fichiers de type
                                <b> png, jpg, jpeg, pdf</b>
                              </>
                            }
                          />
                        </>
                      )}
                    </>
                  )}

                  {fileNameDropzone.cin ? (
                    <>
                      <div className="wrap-result-files">
                        <label className="dropzone-component-label">CIN</label>
                        <div className="wrap-link-files">
                          <div className="wrap-name-files">
                            {FileExtImg(fileNameDropzone.cin || "")}
                            {fileNameDropzone.cin}
                          </div>
                          <RiDeleteBinLine
                            onClick={() => removeElement("cin")}
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <Dropzone
                        label={
                          requestType === "company"
                            ? "CIN du gérant, des associés pour les SARL"
                            : "CIN"
                        }
                        name="cin"
                        hasError={formErrorMessages.cin}
                        errorMessage={
                          <div className="text-danger">
                            {formErrorMessages.cin}
                          </div>
                        }
                        value={valRegister.cin || []}
                        onChange={(files) => {
                          files[0] && convertFileToBase64(files[0], "cin");
                        }}
                        required
                        accept="image/*,.pdf"
                        description={
                          <>
                            Cette dropzone accepte les fichiers de type
                            <b> png, jpg, jpeg, pdf</b>
                          </>
                        }
                      />
                    </>
                  )}

                  {requestType === "farmer" && (
                    <>
                      {fileNameDropzone.titre_de_propriete ? (
                        <>
                          <div className="wrap-result-files">
                            <label className="dropzone-component-label">
                              Titre de propriété agricole
                            </label>
                            <div className="wrap-link-files">
                              <div className="wrap-name-files">
                                {FileExtImg(
                                  fileNameDropzone.titre_de_propriete || ""
                                )}
                                {fileNameDropzone.titre_de_propriete}
                              </div>
                              <RiDeleteBinLine
                                onClick={() =>
                                  removeElement("titre_de_propriete")
                                }
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <Dropzone
                            label="Titre de propriété agricole"
                            name="titre_de_propriete"
                            hasError={formErrorMessages.titre_de_propriete}
                            errorMessage={
                              <div className="text-danger">
                                {formErrorMessages.titre_de_propriete}
                              </div>
                            }
                            value={valRegister.titre_de_propriete || []}
                            onChange={(files) => {
                              files[0] &&
                                convertFileToBase64(
                                  files[0],
                                  "titre_de_propriete"
                                );
                            }}
                            accept="image/*,.pdf"
                            description={
                              <>
                                Cette dropzone accepte les fichiers de type
                                <b> png, jpg, jpeg, pdf</b>
                              </>
                            }
                          />
                        </>
                      )}
                    </>
                  )}

                  {requestType !== "farmer" && (
                    <>
                      {fileNameDropzone.patente ? (
                        <>
                          <div className="wrap-result-files">
                            <label className="dropzone-component-label">
                              Patente
                            </label>
                            <div className="wrap-link-files">
                              <div className="wrap-name-files">
                                {FileExtImg(fileNameDropzone.patente || "")}
                                {fileNameDropzone.patente}
                              </div>
                              <RiDeleteBinLine
                                onClick={() => removeElement("patente")}
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <Dropzone
                            label="Patente"
                            name="patente"
                            hasError={formErrorMessages.patente}
                            errorMessage={
                              <div className="text-danger">
                                {formErrorMessages.patente}
                              </div>
                            }
                            value={valRegister.patente || []}
                            onChange={(files) => {
                              files[0] &&
                                convertFileToBase64(files[0], "patente");
                            }}
                            required
                            accept="image/*,.pdf"
                            description={
                              <>
                                Cette dropzone accepte les fichiers de type
                                <b> png, jpg, jpeg, pdf</b>
                              </>
                            }
                          />
                        </>
                      )}
                    </>
                  )}

                  {fileNameDropzone.facture_proforma ? (
                    <>
                      <div className="wrap-result-files">
                        <label className="dropzone-component-label">
                          Facture PROFORMA
                        </label>
                        <div className="wrap-link-files">
                          <div className="wrap-name-files">
                            {FileExtImg(
                              fileNameDropzone.facture_proforma || ""
                            )}
                            {fileNameDropzone.facture_proforma}
                          </div>
                          <RiDeleteBinLine
                            onClick={() => removeElement("facture_proforma")}
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <Dropzone
                        label="Facture PROFORMA"
                        name="facture_proforma"
                        hasError={formErrorMessages.facture_proforma}
                        errorMessage={
                          <div className="text-danger">
                            {formErrorMessages.facture_proforma}
                          </div>
                        }
                        value={valRegister.facture_proforma || []}
                        onChange={(files) => {
                          files[0] &&
                            convertFileToBase64(files[0], "facture_proforma");
                        }}
                        required
                        accept="image/*,.pdf"
                        description={
                          <>
                            Cette dropzone accepte les fichiers de type
                            <b> png, jpg, jpeg, pdf</b>
                          </>
                        }
                      />
                    </>
                  )}

                  {requestType === "company" && (
                    <>
                      {fileNameDropzone.statuts_a_jour ? (
                        <>
                          <div className="wrap-result-files">
                            <label className="dropzone-component-label">
                              Statuts à jour et Procès-verbal (Si modifications
                              statutaires)
                            </label>
                            <div className="wrap-link-files">
                              <div className="wrap-name-files">
                                {FileExtImg(
                                  fileNameDropzone.statuts_a_jour || ""
                                )}
                                {fileNameDropzone.statuts_a_jour}
                              </div>
                              <RiDeleteBinLine
                                onClick={() => removeElement("statuts_a_jour")}
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <Dropzone
                            label="Statuts à jour et Procès-verbal (Si modifications statutaires)"
                            name="statuts_a_jour"
                            hasError={formErrorMessages.statuts_a_jour}
                            errorMessage={
                              <div className="text-danger">
                                {formErrorMessages.statuts_a_jour}
                              </div>
                            }
                            value={valRegister.statuts_a_jour || []}
                            onChange={(files) => {
                              files[0] &&
                                convertFileToBase64(files[0], "statuts_a_jour");
                            }}
                            required
                            accept="image/*,.pdf"
                            description={
                              <>
                                Cette dropzone accepte les fichiers de type
                                <b> png, jpg, jpeg, pdf</b>
                              </>
                            }
                          />
                        </>
                      )}

                      {fileNameDropzone.repartition_du_capital ? (
                        <>
                          <div className="wrap-result-files">
                            <label className="dropzone-component-label">
                              Répartition du Capital (pour SA)
                            </label>
                            <div className="wrap-link-files">
                              <div className="wrap-name-files">
                                {FileExtImg(
                                  fileNameDropzone.repartition_du_capital || ""
                                )}
                                {fileNameDropzone.repartition_du_capital}
                              </div>
                              <RiDeleteBinLine
                                onClick={() =>
                                  removeElement("repartition_du_capital")
                                }
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <Dropzone
                            label="Répartition du Capital (pour SA)"
                            name="repartition_du_capital"
                            hasError={formErrorMessages.repartition_du_capital}
                            errorMessage={
                              <div className="text-danger">
                                {formErrorMessages.repartition_du_capital}
                              </div>
                            }
                            value={valRegister.repartition_du_capital || []}
                            onChange={(files) => {
                              files[0] &&
                                convertFileToBase64(
                                  files[0],
                                  "repartition_du_capital"
                                );
                            }}
                            accept="image/*,.pdf"
                            description={
                              <>
                                Cette dropzone accepte les fichiers de type
                                <b> png, jpg, jpeg, pdf</b>
                              </>
                            }
                          />
                        </>
                      )}

                      {fileNameDropzone.pouvoirs_du_gerant ? (
                        <>
                          <div className="wrap-result-files">
                            <label className="dropzone-component-label">
                              Pouvoirs du/des Gérants ou DG ou PDG (pour SA)
                            </label>
                            <div className="wrap-link-files">
                              <div className="wrap-name-files">
                                {FileExtImg(
                                  fileNameDropzone.pouvoirs_du_gerant || ""
                                )}
                                {fileNameDropzone.pouvoirs_du_gerant}
                              </div>
                              <RiDeleteBinLine
                                onClick={() =>
                                  removeElement("pouvoirs_du_gerant")
                                }
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <Dropzone
                            label="Pouvoirs du/des Gérants ou DG ou PDG (pour SA)"
                            name="pouvoirs_du_gerant"
                            hasError={formErrorMessages.pouvoirs_du_gerant}
                            errorMessage={
                              <div className="text-danger">
                                {formErrorMessages.pouvoirs_du_gerant}
                              </div>
                            }
                            value={valRegister.pouvoirs_du_gerant || []}
                            onChange={(files) => {
                              files[0] &&
                                convertFileToBase64(
                                  files[0],
                                  "pouvoirs_du_gerant"
                                );
                            }}
                            accept="image/*,.pdf"
                            description={
                              <>
                                Cette dropzone accepte les fichiers de type
                                <b> png, jpg, jpeg, pdf</b>
                              </>
                            }
                          />
                        </>
                      )}
                    </>
                  )}
                  {requestType === "professional" && (
                    <>
                      {fileNameDropzone.carte_professionnelle ? (
                        <>
                          <div className="wrap-result-files">
                            <label className="dropzone-component-label">
                              Carte Professionnelle (pour les professions
                              libérales)
                            </label>
                            <div className="wrap-link-files">
                              <div className="wrap-name-files">
                                {FileExtImg(
                                  fileNameDropzone.carte_professionnelle || ""
                                )}
                                {fileNameDropzone.carte_professionnelle}
                              </div>
                              <RiDeleteBinLine
                                onClick={() =>
                                  removeElement("carte_professionnelle")
                                }
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <Dropzone
                            label="Carte Professionnelle (Obligatoire pour les professions libérales)"
                            name="carte_professionnelle"
                            hasError={formErrorMessages.carte_professionnelle}
                            errorMessage={
                              <div className="text-danger">
                                {formErrorMessages.carte_professionnelle}
                              </div>
                            }
                            value={valRegister.carte_professionnelle || []}
                            onChange={(files) => {
                              files[0] &&
                                convertFileToBase64(
                                  files[0],
                                  "carte_professionnelle"
                                );
                            }}
                            accept="image/*,.pdf"
                            description={
                              <>
                                Cette dropzone accepte les fichiers de type
                                <b> png, jpg, jpeg, pdf</b>
                              </>
                            }
                          />
                        </>
                      )}
                    </>
                  )}
                  {requestType !== "farmer" && (
                    <>
                      {fileNameDropzone.rne ? (
                        <>
                          <div className="wrap-result-files">
                            <label className="dropzone-component-label">
                              Registre National des Entreprises (datant de moins
                              de 03mois)
                            </label>
                            <div className="wrap-link-files">
                              <div className="wrap-name-files">
                                {FileExtImg(fileNameDropzone.rne || "")}
                                {fileNameDropzone.rne}
                              </div>
                              <RiDeleteBinLine
                                onClick={() => removeElement("rne")}
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <Dropzone
                            label="Registre National des Entreprises (datant de moins de 03mois)"
                            name="rne"
                            hasError={formErrorMessages.rne}
                            errorMessage={
                              <div className="text-danger">
                                {formErrorMessages.rne}
                              </div>
                            }
                            value={valRegister.rne || []}
                            onChange={(files) => {
                              files[0] && convertFileToBase64(files[0], "rne");
                            }}
                            required
                            accept="image/*,.pdf"
                            description={
                              <>
                                Cette dropzone accepte les fichiers de type
                                <b> png, jpg, jpeg, pdf</b>
                              </>
                            }
                          />
                        </>
                      )}
                    </>
                  )}

                  {fileNameDropzone.releves_bancaires ? (
                    <>
                      <div className="wrap-result-files">
                        <label className="dropzone-component-label">
                          {requestType === "farmer"
                            ? "Relevés bancaires des 06 derniers mois (Courant / Epargne)"
                            : "Relevés bancaires des 03 derniers mois"}
                        </label>
                        <div className="wrap-link-files">
                          <div className="wrap-name-files">
                            {FileExtImg(
                              fileNameDropzone.releves_bancaires || ""
                            )}
                            {fileNameDropzone.releves_bancaires}
                          </div>
                          <RiDeleteBinLine
                            onClick={() => removeElement("releves_bancaires")}
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <Dropzone
                        label={
                          requestType === "farmer"
                            ? "Relevés bancaires des 06 derniers mois (Courant / Epargne)"
                            : "Relevés bancaires des 03 derniers mois"
                        }
                        name="releves_bancaires"
                        hasError={formErrorMessages.releves_bancaires}
                        errorMessage={
                          <div className="text-danger">
                            {formErrorMessages.releves_bancaires}
                          </div>
                        }
                        value={valRegister.releves_bancaires || []}
                        onChange={(files) => {
                          files[0] &&
                            convertFileToBase64(files[0], "releves_bancaires");
                        }}
                        required
                        accept="image/*,.pdf"
                        description={
                          <>
                            Cette dropzone accepte les fichiers de type
                            <b> png, jpg, jpeg, pdf</b>
                          </>
                        }
                      />
                    </>
                  )}

                  {requestType === "company" && (
                    <>
                      {fileNameDropzone.bilans_et_comptes_annexes ? (
                        <>
                          <div className="wrap-result-files">
                            <label className="dropzone-component-label">
                              Bilans et Comptes Annexes des 3 derniers exercices
                              (Rapports CAC pour les SA)
                            </label>
                            <div className="wrap-link-files">
                              <div className="wrap-name-files">
                                {FileExtImg(
                                  fileNameDropzone.bilans_et_comptes_annexes ||
                                    ""
                                )}
                                {fileNameDropzone.bilans_et_comptes_annexes}
                              </div>
                              <RiDeleteBinLine
                                onClick={() =>
                                  removeElement("bilans_et_comptes_annexes")
                                }
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <Dropzone
                            label="Bilans et Comptes Annexes des 3 derniers exercices (Rapports CAC pour les SA)"
                            name="bilans_et_comptes_annexes"
                            hasError={
                              formErrorMessages.bilans_et_comptes_annexes
                            }
                            errorMessage={
                              <div className="text-danger">
                                {formErrorMessages.bilans_et_comptes_annexes}
                              </div>
                            }
                            value={valRegister.bilans_et_comptes_annexes || []}
                            onChange={(files) => {
                              files[0] &&
                                convertFileToBase64(
                                  files[0],
                                  "bilans_et_comptes_annexes"
                                );
                            }}
                            required
                            accept="image/*,.pdf"
                            description={
                              <>
                                Cette dropzone accepte les fichiers de type
                                <b> png, jpg, jpeg, pdf</b>
                              </>
                            }
                          />
                        </>
                      )}
                    </>
                  )}
                  {requestType === "farmer" && (
                    <>
                      {fileNameDropzone.taxe_de_transport ? (
                        <>
                          <div className="wrap-result-files">
                            <label className="dropzone-component-label">
                              Taxe de transport agricole ou carte grise de
                              matériel agricole (Si pas de relevés bancaires)
                            </label>
                            <div className="wrap-link-files">
                              <div className="wrap-name-files">
                                {FileExtImg(
                                  fileNameDropzone.taxe_de_transport || ""
                                )}
                                {fileNameDropzone.taxe_de_transport}
                              </div>
                              <RiDeleteBinLine
                                onClick={() =>
                                  removeElement("taxe_de_transport")
                                }
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <Dropzone
                            label="Taxe de transport agricole ou carte grise de matériel agricole (Si pas de relevés bancaires)"
                            name="taxe_de_transport"
                            hasError={formErrorMessages.taxe_de_transport}
                            errorMessage={
                              <div className="text-danger">
                                {formErrorMessages.taxe_de_transport}
                              </div>
                            }
                            value={valRegister.taxe_de_transport || []}
                            onChange={(files) => {
                              files[0] &&
                                convertFileToBase64(
                                  files[0],
                                  "taxe_de_transport"
                                );
                            }}
                            accept="image/*,.pdf"
                            description={
                              <>
                                Cette dropzone accepte les fichiers de type
                                <b> png, jpg, jpeg, pdf</b>
                              </>
                            }
                          />
                        </>
                      )}
                    </>
                  )}
                  {requestType !== "company" && (
                    <>
                      {fileNameDropzone.facture_sone_de_steg ? (
                        <>
                          <div className="wrap-result-files">
                            <label className="dropzone-component-label">
                              Facture SONEDE/STEG
                            </label>
                            <div className="wrap-link-files">
                              <div className="wrap-name-files">
                                {FileExtImg(
                                  fileNameDropzone.facture_sone_de_steg || ""
                                )}
                                {fileNameDropzone.facture_sone_de_steg}
                              </div>
                              <RiDeleteBinLine
                                onClick={() =>
                                  removeElement("facture_sone_de_steg")
                                }
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <Dropzone
                            label="Facture SONEDE/STEG"
                            name="facture_sone_de_steg"
                            hasError={formErrorMessages.facture_sone_de_steg}
                            errorMessage={
                              <div className="text-danger">
                                {formErrorMessages.facture_sone_de_steg}
                              </div>
                            }
                            value={valRegister.facture_sone_de_steg || []}
                            onChange={(files) => {
                              files[0] &&
                                convertFileToBase64(
                                  files[0],
                                  "facture_sone_de_steg"
                                );
                            }}
                            required
                            accept="image/*,.pdf"
                            description={
                              <>
                                Cette dropzone accepte les fichiers de type
                                <b> png, jpg, jpeg, pdf</b>
                              </>
                            }
                          />
                        </>
                      )}
                    </>
                  )}
                  {requestType === "professional" && (
                    <>
                      {fileNameDropzone.certificat_de_degrevement_fiscal ? (
                        <>
                          <div className="wrap-result-files">
                            <label className="dropzone-component-label">
                              Certificat de dégrèvement fiscal (pour les Taxis /
                              Louages)
                            </label>
                            <div className="wrap-link-files">
                              <div className="wrap-name-files">
                                {FileExtImg(
                                  fileNameDropzone.certificat_de_degrevement_fiscal ||
                                    ""
                                )}
                                {
                                  fileNameDropzone.certificat_de_degrevement_fiscal
                                }
                              </div>
                              <RiDeleteBinLine
                                onClick={() =>
                                  removeElement(
                                    "certificat_de_degrevement_fiscal"
                                  )
                                }
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <Dropzone
                            label="Certificat de dégrèvement fiscal (Obligatoire pour les Taxis/Louages)"
                            name="certificat_de_degrevement_fiscal"
                            hasError={
                              formErrorMessages.certificat_de_degrevement_fiscal
                            }
                            errorMessage={
                              <div className="text-danger">
                                {
                                  formErrorMessages.certificat_de_degrevement_fiscal
                                }
                              </div>
                            }
                            value={
                              valRegister.certificat_de_degrevement_fiscal || []
                            }
                            onChange={(files) => {
                              files[0] &&
                                convertFileToBase64(
                                  files[0],
                                  "certificat_de_degrevement_fiscal"
                                );
                            }}
                            accept="image/*,.pdf"
                            description={
                              <>
                                Cette dropzone accepte les fichiers de type
                                <b> png, jpg, jpeg, pdf</b>
                              </>
                            }
                          />
                        </>
                      )}

                      {fileNameDropzone.permis_de_conduire ? (
                        <>
                          <div className="wrap-result-files">
                            <label className="dropzone-component-label">
                              Permis de Conduire (pour les Taxis/Louages)
                            </label>
                            <div className="wrap-link-files">
                              <div className="wrap-name-files">
                                {FileExtImg(
                                  fileNameDropzone.permis_de_conduire || ""
                                )}
                                {fileNameDropzone.permis_de_conduire}
                              </div>
                              <RiDeleteBinLine
                                onClick={() =>
                                  removeElement("permis_de_conduire")
                                }
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <Dropzone
                            label="Permis de Conduire (Obligatoire pour les Taxis/Louages)"
                            name="permis_de_conduire"
                            hasError={formErrorMessages.permis_de_conduire}
                            errorMessage={
                              <div className="text-danger">
                                {formErrorMessages.permis_de_conduire}
                              </div>
                            }
                            value={valRegister.permis_de_conduire || []}
                            onChange={(files) => {
                              files[0] &&
                                convertFileToBase64(
                                  files[0],
                                  "permis_de_conduire"
                                );
                            }}
                            accept="image/*,.pdf"
                            description={
                              <>
                                Cette dropzone accepte les fichiers de type
                                <b> png, jpg, jpeg, pdf</b>
                              </>
                            }
                          />
                        </>
                      )}
                    </>
                  )}

                  {fileNameDropzone.rib ? (
                    <>
                      <div className="wrap-result-files">
                        <label className="dropzone-component-label">RIB</label>
                        <div className="wrap-link-files">
                          <div className="wrap-name-files">
                            {FileExtImg(fileNameDropzone.rib || "")}
                            {fileNameDropzone.rib}
                          </div>
                          <RiDeleteBinLine
                            onClick={() => removeElement("rib")}
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <Dropzone
                        label="RIB"
                        name="rib"
                        hasError={formErrorMessages.rib}
                        errorMessage={
                          <div className="text-danger">
                            {formErrorMessages.rib}
                          </div>
                        }
                        value={valRegister.rib || []}
                        onChange={(files) => {
                          files[0] && convertFileToBase64(files[0], "rib");
                        }}
                        required
                        accept="image/*,.pdf"
                        description={
                          <>
                            Cette dropzone accepte les fichiers de type
                            <b> png, jpg, jpeg, pdf</b>
                          </>
                        }
                      />
                    </>
                  )}
                </div>

                <div className="wrap-btn-action-request">
                  <Button variant="light" size="lg">
                    <Link
                      to={`/financing-request/information-applicant/${id}`}
                      className="link-back"
                    >
                      <RiArrowLeftLine />
                      Précedent
                    </Link>
                  </Button>
                  <Button type="submit" size="lg">
                    Suivant
                  </Button>
                </div>
              </form>
            </div>
          </Col>
          <Col md={4}>
            <SidebarRightFinancingRequest />
          </Col>
        </Row>
      </Paper>
    </>
  );
};

export default FinancingRequestStep2;
